import { useTranslation } from 'react-i18next'

import { Checkbox } from '@reveni-io/reveni-ui'

import { returnMethodsWithCarrierSetup } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/constants'

import * as Styles from './styles'

const RequestMultipleLabelsConfiguration = ({ config, onChange, deliveryMethodType, isCarrierConnected, disabled }) => {
  const { t } = useTranslation()

  if (!returnMethodsWithCarrierSetup.includes(deliveryMethodType) || !isCarrierConnected) {
    return null
  }

  return (
    <Styles.Container>
      <Checkbox
        label={t('Permitir a los clientes solicitar múltiples etiquetas de envío sin coste añadido')}
        checked={config?.allows_multiple_return_labels}
        onChange={e => onChange({ allows_multiple_return_labels: e.target.checked })}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default RequestMultipleLabelsConfiguration
